import type {
  CreateWebsiteBannerDto,
  WebsiteBannerDto,
} from '@/generated/korza-api-client/types.gen';

export const DEFAULT_BANNER: CreateWebsiteBannerDto = {
  content: {
    textHtml:
      'Baixe o app e fique por dentro das ofertas e promoções semanais!',
    buttonText: 'BAIXAR',
  },
  theme: {
    bgColor: '#ffffff',
    fgColor: '#000000',
  },
  customStyles: {
    bannerCustomCss: '',
    pageCustomCss: '',
    iframeStyle: '',
  },
  position: {
    placeInside: null,
    placeAfter: null,
    placeBefore: null,
  },
  extraHostnames: [],
  enabled: false,
};

export function bannerDtoToForm(dto: WebsiteBannerDto): CreateWebsiteBannerDto {
  return {
    content: { ...dto.content },
    theme: { ...dto.theme },
    customStyles: { ...dto.customStyles },
    position: dto.position
      ? {
          placeInside: dto.position.placeInside,
          placeAfter: dto.position.placeAfter,
          placeBefore: dto.position.placeBefore,
        }
      : undefined,
    extraHostnames: [...(dto.extraHostnames ?? [])],
    enabled: dto.enabled ?? false,
  };
}

export type PositionMode = 'default' | 'child' | 'before' | 'after';

export function getPositionMode(
  position: CreateWebsiteBannerDto['position']
): PositionMode {
  if (position?.placeInside != null) return 'child';
  if (position?.placeBefore != null) return 'before';
  if (position?.placeAfter != null) return 'after';
  return 'default';
}

export function getPositionSelectorValue(
  position: CreateWebsiteBannerDto['position']
): string {
  return (
    position?.placeInside ?? position?.placeBefore ?? position?.placeAfter ?? ''
  );
}

export function parseExtraHostnames(text: string): string[] {
  return text
    .split(/[\n,]/)
    .map((s) => s.trim())
    .filter(Boolean);
}

export function formatExtraHostnames(hostnames: string[]): string {
  return hostnames.join('\n');
}

/** The banner HTML as plain text: parsed in an inert document, never injected (R12). */
export function bannerPlainText(html: string): string {
  const text =
    new DOMParser().parseFromString(html, 'text/html').documentElement
      .textContent ?? '';
  return text.replace(/\s+/g, ' ').trim();
}
